import DateFnsUtils from '@date-io/date-fns';
import {makeStyles} from '@material-ui/core/styles';
import {
  KeyboardDatePicker,
  MuiPickersUtilsProvider
} from '@material-ui/pickers';
import 'date-fns';
import PropTypes from 'prop-types';
import React from 'react';
import locale from '../locale/Localization';

const useStyles = makeStyles((theme) => ({
  dateField: {
    marginRight: theme.spacing(1),
    width: 250,
    marginLeft: 10,
    paddingBottom: '1%'
  }
}));

/**
 * Material UI Datepicker.
 *
 * @param {*} props - Datepicker form attributes passed as property.
 * @return {String} - The component content.
 */
export default function DatePicker(props) {
  const classes = useStyles();
  const handleDateChange = (date) => {
    if (date instanceof Date) {
      props.handler(date, props.id);
    } else {
      props.handler(null, props.id);
    }
  };

  return (
    <MuiPickersUtilsProvider utils={DateFnsUtils}>
      <div>
        <KeyboardDatePicker
          fullWidth={props.fullWidth ?? false}
          disabled={props.disabled}
          required={props.required}
          disableToolbar
          autoOk={true}
          variant='inline'
          format={locale.datePickerFormat}
          margin={props.margin ? props.margin : 'normal'}
          id={props.id}
          label={props.label}
          value={props.value}
          onChange={handleDateChange}
          className={props.styles ?? classes.dateField}
          invalidDateMessage={locale.datePickerErrorText}
        />
      </div>
    </MuiPickersUtilsProvider>
  );
}

DatePicker.propTypes = {
  id: PropTypes.string.isRequired,
  label: PropTypes.string.isRequired,
  handler: PropTypes.func.isRequired,
  value: PropTypes.string,
  required: PropTypes.bool,
  disabled: PropTypes.bool,
  margin: PropTypes.string,
  fullWidth: PropTypes.bool,
  styles: PropTypes.string
};
